<template>
  <div>
    <b-col
      v-if="info.numberOfPages > 1"
      :lg="nofloatingPagination ? '2' : '12'"
      :offset-lg="nofloatingPagination ? '5' : ''"
      class="center-align"
    >
      <b-input-group
        :class="
          nofloatingPagination ? 'mh-nofloatingPagination' : 'mh-pagination'
        "
      >
        <b-input-group-prepend>
          <b-button @click="$emit('changePage', 1)" :disabled="info.page == 1">
            <b-icon-chevron-double-left></b-icon-chevron-double-left>
          </b-button>
          <b-button
            @click="$emit('changePage', parseInt(info.page) - 1)"
            :disabled="info.page == 1"
          >
            <b-icon-chevron-left></b-icon-chevron-left>
          </b-button>
        </b-input-group-prepend>
        <b-form-input
          v-model="pageValue"
          @keyup.native="enterPage"
          :placeholder="info.page + ' sur ' + info.numberOfPages"
        ></b-form-input>
        <b-input-group-append>
          <b-button
            @click="$emit('changePage', parseInt(info.page) + 1)"
            :disabled="info.page == info.numberOfPages"
          >
            <b-icon-chevron-right></b-icon-chevron-right>
          </b-button>
          <b-button
            @click="$emit('changePage', info.numberOfPages)"
            :disabled="info.page == info.numberOfPages"
          >
            <b-icon-chevron-double-right></b-icon-chevron-double-right>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-col>
  </div>
</template>

<script>
export default {
  props: ["info", "nofloatingPagination"],
  data() {
    return {
      pageValue: "",
    };
  },
  methods: {
    enterPage(event) {
      if (event.which === 13) {
        if (
          parseInt(this.pageValue) >= 1 ||
          parseInt(this.pageValue) <= this.info.numberOfPages
        ) {
          this.$emit("changePage", parseInt(this.pageValue));
          this.pageValue = "";
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mh-nofloatinPagination {
  position: relative;
  width: auto;
}
@media screen and (min-width: 600px) {
  .mh-pagination {
    width: auto;
    z-index: 1000;
    position: fixed;
    bottom: 3%;
    left: 50%;
    box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.14), 0 1px 7px 0 rgba(0, 0, 0, 0.12),
      0 3px 1px -1px rgba(0, 0, 0, 0.2);
    border-radius: 2px;
    input.form-control {
      max-width: 100px;
      text-align: center;
    }
  }
}
</style>